module.exports = __webpack_public_path__ + "94dbb8d572a8c2dfe2526f3efe04eda6.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/amusement-parks/KnottsBerry1.jpg
// module id = 3456
// module chunks = 0